import { Parser as JSON2CSVParser } from 'json2csv';
const csv = ({ fields, rawdata, filename, options = { delimiter: ';', withBOM: true } }) => {
  const { delimiter, withBOM } = options;
  try {
    const parser = new JSON2CSVParser({ fields, delimiter, withBOM });
    const csv = parser.parse(rawdata);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error(err);
  }
};
export default {
  csv
};



// WEBPACK FOOTER //
// ./src/helpers/download.js